/**
 * Preferências de exibição, salvas no navegador.
 *
 * `try/catch` porque `localStorage` lança em modo privado do Safari — a
 * preferência é só conforto visual, nunca algo que possa derrubar a tela por
 * causa disso.
 */

export function lerPref(chave: string, padrao: boolean): boolean {
  try {
    const v = localStorage.getItem(chave)
    return v === null ? padrao : v === '1'
  } catch {
    return padrao
  }
}

export function gravarPref(chave: string, valor: boolean): void {
  try {
    localStorage.setItem(chave, valor ? '1' : '0')
  } catch {
    // conforto visual, não estado essencial — segue sem salvar
  }
}
